module.exports = __webpack_public_path__ + "img/8kana.c8e1b7e3.png";